import { render } from "./CompanyList.vue?vue&type=template&id=db98c74c&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=db98c74c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db98c74c"]])

export default __exports__